import LegalPage from './LegalPage';

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      title="개인정보 처리방침"
      mdPath="/legal/privacy-policy.md"
    />
  );
}
